import * as angular from 'angular';
import * as angulartics from 'angulartics';
import * as angularTranslate from 'angular-translate';
import * as uiTabs from 'angular-ui-bootstrap/src/tabs';
import './style.less';
import { templatesRun } from './templates.run';
import { GroupSettingsPanelService } from './group-settings-panel.service';
import { SidePanelModule } from 'go-modules/side-panel';
import { groupDepModel } from 'go-modules/models/group-dep';
import { userModel } from 'go-modules/models/user';
import { masqueradeModule } from 'go-modules/masquerade';
import { helpUrlsModule } from 'go-modules/help-urls';
import { groupsIndexModule } from 'go-modules/groups-index';
import { messageModalModule } from 'go-modules/modals/message';
import { ngxGoToastModule } from '@go-modules/components/go-toast';
import { commonFiltersModule } from 'go-modules/common-filters';
import { ManageUsersController } from 'go-modules/group-settings-panel/manage-users.controller';
import { SelectedModule } from 'go-modules/services/selected';
import { goModal } from 'go-modules/modals';
import { courseTemplateModule } from 'go-modules/course-template';
import { ngxRouterServiceModule } from '@go-modules/services/router';
import { ngxOrgSettingsModule } from '@go-modules/components/org-settings';

export const groupSettingsPanelModule = angular.module('group-settings-panel', [
	uiTabs,
	angularTranslate,
	SidePanelModule,
	SelectedModule,
	groupDepModel,
	angulartics,
	courseTemplateModule,
	goModal,
	userModel,
	masqueradeModule,
	helpUrlsModule,
	groupsIndexModule,
	messageModalModule,
	ngxGoToastModule,
	commonFiltersModule,
	ngxRouterServiceModule,
	ngxOrgSettingsModule
])
	.controller('ManageUsersController', ManageUsersController)
	.service(GroupSettingsPanelService.NG1_INJECTION_NAME, GroupSettingsPanelService)
	.run(templatesRun)
	.name;
